module.exports = "<div dropdown-append-to-body\r\n     uib-dropdown>\r\n\r\n  <div uib-dropdown-toggle\r\n       ng-transclude=\"trigger\">\r\n  </div>\r\n\r\n  <rw-list ng-class=\"{'rw-list--scrollable': $ctrl.locations.length > 5}\"\r\n           uib-dropdown-menu>\r\n     <rw-list-item ng-repeat=\"retailer in $ctrl.locations\"\r\n                   ng-click=\"$ctrl.selectRetailer(retailer)\">\r\n       <rw-retailer-info retailer=\"retailer\">\r\n       </rw-retailer-info>\r\n     </rw-list-item>\r\n   </rw-list>\r\n</div> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-subordinates/components/rw-subordinates-dropdown/rw-subordinates-dropdown.html
// module id = 2001
// module chunks = 0